import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

export enum WarningIconStyle {
  OUTLINED = 'OUTLINED',
  FILLED = 'FILLED',
}

export enum WarningType {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

@Component({
  selector: 'app-warning-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './warning-icon.component.html',
  styleUrls: ['./warning-icon.component.scss']
})
export class WarningIconComponent implements OnInit {
  WarningIconStyle = WarningIconStyle;
  
  @Input() type: WarningType = WarningType.WARNING;
  @Input() style: WarningIconStyle = WarningIconStyle.FILLED;

  constructor() { }

  ngOnInit(): void {
  }

}
